<template>
    <div class="transition items-center inline-block w-full">

          <div v-show="isHidden">
            <p>
              {{content}}<a v-on:click="isHidden = !isHidden" :class="['align-middle cursor-pointer', buttonsize]"><i :class="['material-icons align-middle mx-1', buttonsize]">{{buttonicon}}</i>{{buttonname}}</a>
            </p>
          </div>
          <div v-if="!isHidden" class="dropdown flex w-56 transition items-center">
              
              <div class="flex-1 pr-1 w-10/12">
                <v-select
                  :options="options"
                  label="name"
                  v-model="selected"
                  :placeholder="placeholder"
                  class="text-xs leading-normal"
                  >
                  </v-select>
              </div>
              <div class="w-2/12">
                  <button 
                    v-if="selected"
                    @click="putItem" 
                    type="submit" 
                    class="commitbutton p-0 inline-block"
                    :class="{ 'loading': submitting }"
                  ><i aria-hidden="true" class="material-icons align-middle text-3xl">check</i></button>
              </div>
            <div v-if="errors.length">
              <p v-for="error in errors"
                class="leading-tight text-red-700 text-xs pb-0 my-3"
              >
                {{ error }}
              </p>
            </div>
          </div>
        
      </div>
</template>

<script>
import VueSelect from 'vue-select';
import axios from 'axios'

  export default {
        
        components: { VueSelect },

        props: {
            options: '',
            placeholder: {
                default: 'Select Item' 
            },
            route:'',
            idname:'',
            content: '',
            route:'',
            routeparam:'',
            buttonname: {
              default: 'Change',
            },
            buttonicon: {
              default: 'edit',
            },
            buttonsize: {
              default: 'text-xs',
            },
        },

        data() {
          return {
            isHidden: true,
            submitting: false,
            errors: [],
            name: '',
            selected: '',
          }
        },

        methods: {

          show() {
            this.isHidden = ! this.isHidden;
            this.focusOnField();
          },
          focusOnField() {
            this.$nextTick(() => {
              this.$refs.input?.focus();
            });
          },

          putItem: function (event) {
            if (! this.submitting) {
              this.submitting = true;
              this.errors = [];
              axios.put(
                  this.route,{ [this.routeparam]: this.selected.value }
                ).then(() => {
                  location.reload();
                })
                .catch((errors) => {
                  this.submitting = false;
                  this.errors = errors.response?.data?.errors?.[this.routeparam] || [];
                })
            };
          }

        },
      }
</script>
